import React, { useEffect, useState } from "react";
import { message, Layout, Modal, } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import logo from "./../assets/img/BAbianco.png"
import { checkTokenOperatore } from "../services/api";

const { Content, Header } = Layout;
const { innerWidth, innerHeight } = window;

const SetIsTotem = () => {
  const navigate = useNavigate();


  useEffect(() => {
    navigate('/homepage', { state: {isTotem: true}})
  }, [])



  return (
    <></>

  );
};

export default SetIsTotem;
